module.exports = __webpack_public_path__ + "img/top.ffd8122f.png";